export {StudyDetails} from './study-details';
